import React from 'react';
import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import MediaQuery from 'react-responsive';
import './styles.css';

const FiltersForm = ({
  label,
  title,
  subTitle,
  accordions,
  disabled,
  hideControls,
  onClearAll,
  onSaveForm,
}) => {
  const disableAction = () => {};

  return (
    <div className="filters-accordion-form">
      <div className="filters-accordion-form__header">
        <h4 className="filters-accordion-form__title">{title}</h4>
        {subTitle && (
          <p className="filters-accordion-form__description">{subTitle}</p>
        )}
      </div>

      <div className="filters-accordion-form__filters-list">{accordions}</div>

      {!hideControls && (
        <div className="filters-accordion-form__controls">
          <BasicButtonGroup>
            <MediaQuery query="(max-width: 767px)">
              <button
                type="button"
                className="filters-accordion__filters-reset-btn"
                onClick={disabled ? disableAction : onClearAll}
              >
                <span className="filters-accordion__btn-icon" />
                clear filters
              </button>
            </MediaQuery>
            <BasicButton
              controlFunc={disabled ? disableAction : onSaveForm}
              btnWidth={200}
              btnHeight={40}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnText="Save"
            />
            <MediaQuery query="(min-width: 768px)">
              <button
                type="button"
                className="filters-accordion__filters-reset-btn"
                onClick={disabled ? disableAction : onClearAll}
              >
                <span className="filters-accordion__btn-icon" />
                clear filters
              </button>
            </MediaQuery>
          </BasicButtonGroup>
        </div>
      )}
    </div>
  );
};

export default FiltersForm;
